import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import FeaturedProject from "@/components/FeaturedProject";
import Marquee from "@/components/Marquee";
import Realisaties from "@/components/Realisaties";
import About from "@/components/About";
import WhyChooseUs from "@/components/WhyChooseUs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

// Temporarily hidden; keep the section available for possible future reactivation.
const SHOW_WHY_CHOOSE_US = false;

const scrollToTarget = (target) => {
  if (target === "top") {
    window.scrollTo({ top: 0 });
    return;
  }
  const el = document.getElementById(target);
  if (!el) return;
  el.scrollIntoView();
};

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const stateTarget = location.state?.scrollTo;
    const hashTarget = location.hash ? location.hash.replace("#", "") : null;
    const target = stateTarget || hashTarget;
    if (target) {
      scrollToTarget(target);
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div className="bg-white">
      <Navbar />
      <main>
        <Hero
          onPrimaryProject={() => scrollToTarget("project-in-de-kijker")}
          onSecondaryProject={() => scrollToTarget("realisaties")}
        />
        <FeaturedProject />
        <Marquee />
        <Realisaties />
        <About />
        {SHOW_WHY_CHOOSE_US && <WhyChooseUs />}
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
